import PropTypes from 'prop-types'
import React from 'react'
import compose from 'recompose/compose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { List } from 'immutable'
import PlanCardGrid from '../../PlanCardGrid/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { connect as connectStaticText } from '../../StaticText/connect'
import CartProgressIndicator from '../../CartProgressIndicator/index'
import { H1, HEADING_TYPES } from '../../Heading/index'
import OptimizelyPage from '../../OptimizelyPage/index'
import CartLayoutTemplate from '../CartLayoutTemplate/index'
import OptimizelyTest from '../../OptimizelyTest/index'
import { historyRedirect } from '../../../services/navigation/index'
import { URL_CART_BILLING } from '../../../services/url/constants'
import { getPrimary } from '../../../services/languages/index'

function CartPlansPageV2 (props) {
  const {
    app,
    auth,
    user,
    history,
    staticText,
  } = props

  // Horizontal Plan Grid 5062284385452032
  const isMobile = app.getIn(['viewport', 'width']) < 1194
  const language = getPrimary(user.getIn(['data', 'language'], List()))

  return (
    <div className="cart-plans-page-v2">
      <CartLayoutTemplate
        colOne={
          <React.Fragment>
            {/* Horizontal Plan Grid 5062284385452032 */}
            <OptimizelyTest
              original
              experimentId={'5062284385452032'}
              variantId={'6010936142594048'}
            >
              <div className="cart-plans-page-v2__wrapper">
                <CartProgressIndicator v2 />
                <H1 as={HEADING_TYPES.H3} className="cart-plans-page-v2__title">
                  {staticText.getIn(['data', 'choosePlan'])}
                </H1>
                <PlanCardGrid history={history} shouldScrollToTop />
              </div>
            </OptimizelyTest>
            <OptimizelyTest
              original={false}
              experimentId={'5062284385452032'}
              variantId={'5736688790536192'}
            >
              <div className={`cart-plans-page-v2__wrapper cart-plans-page-v2__wrapper--${isMobile ? 'mobile' : 'desktop'}`}>
                <CartProgressIndicator v2 />
                <H1 as={HEADING_TYPES.H3} className="cart-plans-page-v2__title">
                  {staticText.getIn(['data', 'choosePlan'])}
                </H1>
                <PlanCardGrid
                  shouldScrollToTop
                  history={history}
                  sliderMode={true}
                  isMobile={isMobile}
                  onPlanSelect={() => {
                    historyRedirect({
                      history,
                      url: URL_CART_BILLING,
                      auth,
                      language,
                    })
                  }}
                />
              </div>
            </OptimizelyTest>
            {/* Checkout CTA Copy Test 5062284385452032 */}
            <OptimizelyPage pageName="web_app__cart_plan_selection_plans" />
          </React.Fragment>
        }
      />
    </div>
  )
}

CartPlansPageV2.propTypes = {
  history: PropTypes.object.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectStaticText({ storeKey: 'cartPlansPageV2' }),
  connectRedux(
    (state) => ({
      app: state.app,
      auth: state.auth,
      user: state.user,
    }),
  ),
)(CartPlansPageV2)
